import React from 'react'
import { Link } from 'react-router-dom'

const Cancel = () => {
    return (<>
        <div className='container mx-auto justify-between h-auto my-[10px] md:my-[46px] flex-row'>

            <div class="flex p-4 mb-4 text-sm mx-auto bg-amber-50" role="alert">

                <div className=' mx-auto flex'>
                    <div class="mr-3 w-9 h-9 p-2 bg-amber-100 rounded-full">
                        <svg class="flex-shrink-0 w-5 h-5" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M10.0048 13.3333V9.16663M10.0003 6.66663H10.0078M10.0003 18.3333C5.39795 18.3333 1.66699 14.6023 1.66699 9.99996C1.66699 5.39759 5.39795 1.66663 10.0003 1.66663C14.6027 1.66663 18.3337 5.39759 18.3337 9.99996C18.3337 14.6023 14.6027 18.3333 10.0003 18.3333Z" stroke="#F59E0B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                    </div>
                    <div class="block">
                        <h3 class="text-amber-800 font-normal mb-1">
                            <span class="font-semibold mr-1">Error</span> Your payment has been cancelled or decliend,
                        </h3>
                        <p class="text-gray-600 text-sm">Please verify your payment information and then try again.</p>
                        <div class="flex items-center gap-6 mt-4">
                            <Link to={"/OnlineOrdering"}>
                                <button class="font-semibold text-gray-900 transition-all duration-500 hover:text-amber-500">Continue Shopping</button>
                            </Link>

                            <Link to={"/OnlineOrdering/cart"}>
                                <button class="font-semibold text-gray-900 transition-all duration-500 hover:text-amber-500">Try again</button>

                            </Link>
                        </div>
                    </div>
                </div>
            </div>
                   </div>

    </>

    )
}

export default Cancel
